import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { TakNieModalComponent } from 'src/app/komponenty/ogolne/tak-nie-modal/tak-nie-modal.component';
import { KonfiguracjaPomieszczen } from 'src/app/modele/projekty/konfiguracjaPomieszczen/konfiguracjaPomieszczen';
import { DodajPomieszczenieModel } from 'src/app/modele/projekty/pomieszczenia/dodajPomieszczenieModel';
import { SlownikPolaPomieszczenia } from 'src/app/modele/projekty/pomieszczenia/slownikPolaPomieszczenia';
import { IdModel } from 'src/app/modele/wspolne/id.model';
import { ModalOpcje } from 'src/app/modele/wspolne/modal-opcje.ogolne';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { PomieszczeniaService } from 'src/app/serwisy/projekty/pomieszczenia.service';

@Component({
  selector: 'app-dodaj-pomieszczenie-modal',
  templateUrl: './dodaj-pomieszczenie-modal.component.html',
  styleUrls: ['./dodaj-pomieszczenie-modal.component.css']
})
export class DodajPomieszczenieModalComponent extends BazowyComponent implements OnInit {

  idLokalizacji: string;
  model: DodajPomieszczenieModel = new DodajPomieszczenieModel();
  czyZaladowanoDane: boolean;
  konfiguracja: KonfiguracjaPomieszczen;
  slowniki: Array<SlownikPolaPomieszczenia> = new Array();
  czyPrzenoszenieSrodkow: boolean;
  pomieszczenieAktualneNazwa: string

  nazwaSlownik: Array<string> = new Array();
  pietroSlownik: Array<string> = new Array();
  mpkSlownik: Array<string> = new Array();
  opisDodatkowySlownik: Array<string> = new Array();
  osobaSlownik: Array<string> = new Array();
  inneSlownik: Array<string> = new Array();

  nazwaSlownikObs: Observable<string[]>;
  pietroSlownikObs: Observable<string[]>;
  mpkSlownikObs: Observable<string[]>;
  opisDodatkowySlownikObs: Observable<string[]>;
  osobaSlownikObs: Observable<string[]>;
  inneSlownikObs: Observable<string[]>;

  nazwaFC = new UntypedFormControl();
  pietroFC = new UntypedFormControl();
  mpkFC = new UntypedFormControl();
  opisDodatkowyFC = new UntypedFormControl();
  osobaFC = new UntypedFormControl();
  inneFC = new UntypedFormControl();

  constructor(
    public router: Router,
    modalService: NgbModal,
    public activeModal: NgbActiveModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public pomieszczeniaSerwis: PomieszczeniaService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute) {
    super(authService, modalService, loaderSerwis, komunikatSerwis, router, translateSerwis);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.pobierzDaneDoEkranu();
    });
  }

  pobierzDaneDoEkranu() {
    var model = new IdModel();
    model.id = this.idLokalizacji;

    this.pomieszczeniaSerwis.pobierzDaneKonfiguracyjneDoEdycjiPomieszczenia(model).subscribe(
      (rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.konfiguracja = rezultat.element.konfiguracjaPomieszczen;
          this.slowniki = rezultat.element.slowniki;
          this.czyZaladowanoDane = true;

          if (this.konfiguracja.nazwaSlownikId) {
            this.nazwaSlownik = this.slowniki.find(m => m.id == this.konfiguracja.nazwaSlownikId).wartosci;
            this.nazwaSlownikObs = this.nazwaFC.valueChanges.pipe(startWith(''), map(m => this.filtrujSlownikNazw(m)));
          }
          if (this.konfiguracja.pietroSlownikId) {
            this.pietroSlownik = this.slowniki.find(m => m.id == this.konfiguracja.pietroSlownikId).wartosci;
            this.pietroSlownikObs = this.pietroFC.valueChanges.pipe(startWith(''), map(m => this.filtrujSlownikPietro(m)));
          }
          if (this.konfiguracja.mpkSlownikId) {
            this.mpkSlownik = this.slowniki.find(m => m.id == this.konfiguracja.mpkSlownikId).wartosci;
            this.mpkSlownikObs = this.mpkFC.valueChanges.pipe(startWith(''), map(m => this.filtrujSlownikMpk(m)));
          }
          if (this.konfiguracja.opisDodatkowySlownikId) {
            this.opisDodatkowySlownik = this.slowniki.find(m => m.id == this.konfiguracja.opisDodatkowySlownikId).wartosci;
            this.opisDodatkowySlownikObs = this.opisDodatkowyFC.valueChanges.pipe(startWith(''), map(m => this.filtrujSlownikOpis(m)));
          }
          if (this.konfiguracja.osobaSlownikId) {
            this.osobaSlownik = this.slowniki.find(m => m.id == this.konfiguracja.osobaSlownikId).wartosci;
            this.osobaSlownikObs = this.osobaFC.valueChanges.pipe(startWith(''), map(m => this.filtrujSlownikOsoba(m)));
          }
          if (this.konfiguracja.inneSlownikId) {
            this.inneSlownik = this.slowniki.find(m => m.id == this.konfiguracja.inneSlownikId).wartosci;
            this.inneSlownikObs = this.inneFC.valueChanges.pipe(startWith(''), map(m => this.filtrujSlownikInne(m)));
          }

          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      }
    );
  }


  zapisz() {
    this.model.idLokalizacji = this.idLokalizacji;

    if (this.czyPrzenoszenieSrodkow) {
      var komunikat = `Czy na pewno chcesz po zapisie przenieść środki z pomieszczenia ${this.pomieszczenieAktualneNazwa} do tego pomieszczenia?`

      var modalReference = this.modalService.open(TakNieModalComponent, new ModalOpcje(true, 'static'));
      modalReference.componentInstance.pytanie = komunikat;
      modalReference.result.then((result) => {
        if (result) {
          this.zapiszIPrzenies()
        }
      }, onRejected => { });
      return
    }
    this.pomieszczeniaSerwis.dodajPomieszczenie(this.model).subscribe(
      (rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.wyswietlKomunikat("Pomieszczenie zostało dodane");
          this.activeModal.close(true);
          return;
        }
        if (this.bladModelu(rezultat)) {
          this.bledyWalidacji = rezultat.bledyModelu;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      }
    );
  }

  zapiszIPrzenies() {
    this.pomieszczeniaSerwis.dodajPomieszczenie(this.model).subscribe(
      (rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.activeModal.close(
            {
              id: rezultat.element,
              nazwa: this.model.nazwa
            }
          );
          return;
        }
        if (this.bladModelu(rezultat)) {
          this.bledyWalidacji = rezultat.bledyModelu;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      }
    );
  }


  private filtrujSlownikNazw(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.nazwaSlownik.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 200);
  }

  private filtrujSlownikPietro(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.pietroSlownik.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 200);
  }

  private filtrujSlownikMpk(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.mpkSlownik.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 200);
  }

  private filtrujSlownikOpis(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.opisDodatkowySlownik.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 200);
  }

  private filtrujSlownikOsoba(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.osobaSlownik.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 200);
  }

  private filtrujSlownikInne(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.inneSlownik.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 200);
  }

}
